<script setup lang="ts">
    import { computed } from 'vue';
    import { ChannelIcon } from '@/js/services/api/interaction/types';
    import { HeadphonesIcon, HeartIcon, MailIcon, MessageSquareIcon } from '@lucide/vue';

    const props = withDefaults(
        defineProps<{
            channelIcon?: ChannelIcon;
            grayScale?: boolean;
            isNew?: boolean;
            size?: 'md' | 'lg';
        }>(),
        { size: 'md' }
    );

    const icon = computed(() => {
        switch (props.channelIcon) {
            case ChannelIcon.MAIL:
                return MailIcon;
            case ChannelIcon.CHAT:
                return MessageSquareIcon;
            case ChannelIcon.TEXT:
                return MessageSquareIcon;
            case ChannelIcon.HEADPHONES:
                return HeadphonesIcon;
            case ChannelIcon.HEART:
                return HeartIcon;
            default:
                return null;
        }
    });

    const color = computed(() => {
        if (props.grayScale) {
            return 'bg-gray-light text-gray-lightest';
        }
        switch (props.channelIcon) {
            case ChannelIcon.MAIL:
                return 'bg-primary-carrot-50 text-primary-carrot-600';
            case ChannelIcon.CHAT:
                return 'bg-primary-avocado-50 text-primary-avocado';
            case ChannelIcon.TEXT:
                return 'bg-primary-avocado-50 text-primary-avocado';
            case ChannelIcon.HEADPHONES:
                return 'bg-primary-beet-50 text-primary-beet';
            case ChannelIcon.HEART:
                return 'bg-primary-plum-50 text-primary-plum';
            default:
                return '';
        }
    });
</script>
<template>
    <div
        class="relative flex items-center justify-center"
        :class="[
            color,
            size === 'lg'
                ? 'size-11 min-w-11 min-h-11 rounded-xl'
                : 'size-10 min-w-10 min-h-10 rounded-md',
        ]"
    >
        <div
            v-if="isNew"
            class="bg-primary-carrot w-2.5 h-2.5 rounded-full absolute -top-1.25 -right-1.25"
        />
        <component :is="icon" v-if="icon" :class="size === 'lg' ? 'size-5.5' : 'size-4.5'" />
    </div>
</template>
